<template>
    <b-row class="overall-bg supplierdetails">
        <b-col sm="10" xl="6" lg="6" md="6">
            <b-row class="pb-5">
                <b-col>
                    <!-- {{ SupformData }} -->
                    <MemberDetails status="1" :dataObj="SupformData" />
                </b-col>
            </b-row>
            <b-row class="pb-5">
                <b-col>
                    <div>
                        <!-- {{ contactlist }} -->
                        <ContactDetails :dataObj="contactlist" />
                    </div>
                </b-col>
            </b-row>
            <b-row class="pb-5">
                <b-col>

                    <Tax :dataObj="objtaxdatadetails" />
                </b-col>
            </b-row>

        </b-col>
        <b-col sm="10" xl="5" lg="5" md="5">
            <b-row class="pb-5 mt-5">
                <b-col>
                    <!-- {{ objblackdetails }} -->
                    <SupplierBlackCardInfo :dataObj="objblackdetails" />
                </b-col>
            </b-row>
            <!-- <b-row class="pb-5">
                <b-col>
                    <PaymentTerms :dataObj="insert_contactdetails" />
                </b-col>
            </b-row> -->
            <b-row class="pb-5">
                <b-col>
                    <BankInfo :dataObj="objdatabankdetails" />
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>
<script lang="ts">

import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import { defineComponent, ref, h, computed, onMounted, watch } from "vue";
import Details from "../../../../../modules/Inventory/components/MasterDetails/Details.vue";
import MemberDetails from "../../../../../modules/Inventory/components/MasterDetails/MemberDetails.vue";
import ContactDetails from '../ContactDetails.vue'
import Tax from '../Tax.vue'
import PaymentTerms from '../PaymentTerms.vue'
import BankInfo from '../BankInfo.vue'
import SupplierBlackCardInfo from '../SupplierBlackCardInfo.vue'
import service from "./../../../Service/SupplierMaster";
import SupplierContactDetailsService from "../../../Service/SupplierContactDetailsService";
import moment from "moment";

export default defineComponent({
    components: {
        Details,
        MemberDetails,
        ContactDetails,
        Tax,
        PaymentTerms,
        BankInfo,
        SupplierBlackCardInfo,
    },

    setup() {
        const router = useRouter();
        const routers = useRoute();
        let contactlist: any = ref([])
        const ParamValues = ref({
            Id: 0,
        });
        let Id = routers.query.Id;
        ParamValues.value.Id = Number(Id);


        onMounted(() => {
            init();
        })

        watch(
            () => routers.query.Id,
            (newVal: any) => {
                debugger;

                ParamValues.value.Id = Number(newVal);
                init();
            }
        );

        const insert_contactdetails = ref({
            Id: 0,
            SupplierId: 0,
            ContactPerson: "",
            ContactDesignation: "",
            Phone: "",
            Email: "",
            Web: "",
            LaneLine: "",
            Fax: "",
            index: 0
        });

        const objcontactdetails = ref({
            ContactPerson: "",
            ContactDesignation: "",
            Phone: "",
            Email: "",
            Web: "",
        });

        const objblackdetails = ref({
            LifeTimeGRN: "",
        });

        // BANK DETAILS JSON
        const objdatabankdetails = ref({
            BankName: "",
            BankAcNo: "",
            ReBankAcNo: "",
            BankBranch: "",
            IFSC: "",
        });

        // ADDRESS DETAILS
        const objaddressdetails = ref({
            StreetName: "",
            Landmark: "",
            Address: "",
            City: 0,
            State: 0,
            Country: 0,
            Pin: "",
        });

        // TAX DETAILS
        const objtaxdatadetails = ref({
            VATNo: "",
            ServiceTaxNo: "",
            ExciseCode: "",
            IncomeTaxNo: "",
            GSTNO: "",
            MSME: "",
            RTGSCODE: "",
            DrugLicence: "",
            CST: "",
        });

        // PAYMENT TERMS DETAILS
        const objdatapaymentsterms = ref({
            PayTermsId: 0,
            CreditPeriod: 0,
            DateOfAssociation: null,
            DiscountPer: 0,
        });


        // form data json
        const SupformData = ref({
            CreatedAt: "",
            CreatedBy: 0,
            ModifiedAt: "",
            ModifiedBy: 0,
            Id: 0,
            Code: "",
            Name: "",
            Tds: "",
            Note: "",
            HospitalId: 0,
            BranchId: 0,
            AccountNo: 0,
            Village: 0,
            SupplierCategory: "",
            DeliveryTermsId: 0,
            OtherTermsId: 0,
            EntityId: 0,
            EntityOperationId: 0,

            StreetName: "",
            Landmark: "",
            Address: "",
            City: ref(),
            State: ref(),
            Country: ref(),
            Pin: "",
        });

        async function init() {
            debugger;
            if (ParamValues.value.Id != undefined) {
                try {
                    // label.value = "Update";
                    const EditID = ParamValues.value.Id;
                    console.log(EditID);
                    try {
                        // loading.value = true;

                        const response = await service.EditData(EditID);
                        const data1 = response["result"][0];

                        console.log(SupformData.value);
                        console.log(objaddressdetails.value);
                        console.log(objdatabankdetails.value);
                        console.log(objcontactdetails.value);
                        console.log(objtaxdatadetails.value);
                        console.log(objdatapaymentsterms.value);

                        Object.keys(SupformData.value).forEach((key) => {
                            if (data1[key]) SupformData.value[key] = data1[key];
                        });
                        Object.keys(objaddressdetails.value).forEach((key) => {
                            if (data1[key]) objaddressdetails.value[key] = data1[key];
                        });
                        Object.keys(objdatabankdetails.value).forEach((key) => {
                            if (data1[key]) objdatabankdetails.value[key] = data1[key];
                        });
                        Object.keys(objcontactdetails.value).forEach((key) => {
                            if (data1[key]) objcontactdetails.value[key] = data1[key];
                        });
                        Object.keys(objtaxdatadetails.value).forEach((key) => {
                            if (data1[key]) objtaxdatadetails.value[key] = data1[key];
                        });

                        Object.keys(objblackdetails.value).forEach((key) => {
                            if (data1[key]) objblackdetails.value[key] = data1[key];
                        });


                        Object.keys(objdatapaymentsterms.value).forEach((key) => {
                            if (key == "DateOfAssociation") {
                                const regex = /^\d{2}-\d{2}-\d{4}$/;
                                let dateOfAssociation: any;
                                if (data1[key]) {
                                    dateOfAssociation = moment(data1[key]).format("DD-MM-YYYY");
                                }
                                data1[key] = dateOfAssociation;
                            }
                            else {
                                if (data1[key]) objdatapaymentsterms.value[key] = data1[key];
                            }
                        });
                        const contactdata_response = await SupplierContactDetailsService.Edit(EditID);
                        contactlist.value = contactdata_response["result"];
                        // loading.value = false;
                    } catch (error) {
                        // loading.value = false;
                        alert(error);
                    }
                } catch (error) {
                    console.error(error);
                }
            } else {
            }
        }

        return {
            SupformData,
            insert_contactdetails,
            objtaxdatadetails,
            objblackdetails,
            contactlist,
            objdatabankdetails

        };
    },
});
</script>

<style lang="scss" scoped>
.supplierdetails {
    height: 63vh;
    overflow: auto;
}

@media screen and (min-width: 1400px) {

    .supplierdetails {
        height: 69vh !important;
    }
}
</style>